(() => {
    let containers = document.querySelectorAll(".js-text-animations");
   
    containers.forEach((container) => {
        let data = container.dataset;
        let texts = container.querySelectorAll(".js-text-animations__text");
        container.style.position = "relative";

        container.style.width = data.containerWidth;
        container.style.height = data.containerHeight;

        let frame = 0;
        animate(texts, frame, data);

        setInterval(() => {
            frame++;

            if (frame >= texts.length) {
                frame = 0;
            }
            
            animate(texts, frame, data);

            
        }, 2500);
    });

    function animate(items, frame, data) {

        items.forEach((text, i) => {
            if(i == frame){
                text.style.position = "absolute";
                text.style.visibility = "visible";
                text.style.top = data.itemsTop;
                text.style.left = data.itemsLeft;
                text.style.transform = "translate(-50%, -50%)";
            } else {
                text.style.position = "absolute";
                text.style.visibility = "hidden";
                text.style.top = "-500%";
                text.style.left= data.itemsLeft;  
                text.style.transform = "translate(-50%, -50%)";
                text.style.transition = "all 0.2s ease-in-out";
            }
        });     
    }
})();
